import { useSearchParams } from "react-router-dom";

import { parseDays } from "./kpi";

/**
 * The KPI dashboard's period, kept in the URL (?days=) so the dashboard, the top-100 page and the
 * back button agree on it. Setting it keeps the URL's other parameters and replaces the history
 * entry (stepping through periods isn't navigation).
 */
export function useKpiPeriod(): [number, (days: number) => void] {
  const [params, setParams] = useSearchParams();
  const setDays = (days: number) =>
    setParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.set("days", String(days));
        return next;
      },
      { replace: true },
    );
  return [parseDays(params.get("days")), setDays];
}
